import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { getEarlyRequestResult } from '../utils/earlyRequest';
const ENDPOINT = 'fintech-discounts/v4/promotions';
export const GET_PROMOTIONS = registerQuery({
  fieldName: 'promotions',
  args: ['earlyRequestName'],
  fetcher({
    earlyRequestName
  }) {
    const fetchPromotions = () => http.get(ENDPOINT);
    return earlyRequestName ? getEarlyRequestResult(earlyRequestName, fetchPromotions) : fetchPromotions();
  }
});